import React from 'react'
import ClientProfile from '../../client/ClientProfile'
import V3ProfileRouteShell from '../profile/V3ProfileRouteShell'

export default function V3ClientProfilePage() {
  return (
    <V3ProfileRouteShell>
      <ClientProfile visualVariant="v3" />
    </V3ProfileRouteShell>
  )
}

